/**
 * @file axios请求封装
 * @author shecaihua(shecaihua@baidu.com)
 */
import axios from 'axios';
import {message} from 'antd';
const instance = axios.create({
    timeout: 5000,
    // baseURL: 'http://yapi.baidu-int.com/mock/4034/'
    headers: {'x-requested-with': 'XMLHttpRequest'},
});

instance.interceptors.request.use((config: any) => {
    return config;
}, (error: Error) => {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use((response: any) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    const data = response.data;
    if (data.success) {
        // 接口有两种 没有分页取 result 有分页就是page
        return data.result || data.page;
    }
    // 如果 302就是重定向
    if (data.code === 302) {
        location.href = data.message && data.message.redirect || '/my-app';
        return;
    }
    message.error(data.message);
    return Promise.reject(data);
}, error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response erro
    message.error(error.response.data.message);
    return Promise.reject(error);
});
export default instance;
